/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type TransparencyEnum = "None" | "Opaque" | "Transparent" | "%future added value";
export type UrnTypeEnum = "Email" | "Integration" | "Org" | "Phone" | "User" | "%future added value";
export type OnboardingAutopilotEvent_event = {
    readonly isClockwiseEvent: boolean;
    readonly calendarIds: ReadonlyArray<string>;
    readonly eventKey: {
        readonly id: string;
        readonly calendarIds: ReadonlyArray<string> | null;
        readonly externalEventId: string;
        readonly hashedCalendars: string | null;
        readonly orgId: string | null;
    };
    readonly organizerPerson: {
        readonly isYou?: boolean | undefined;
        readonly primaryEmail?: string | undefined;
    } | null;
    readonly attendees: ReadonlyArray<{
        readonly displayName: string | null;
        readonly profileId: string | null;
        readonly optional: boolean | null;
        readonly organizer: boolean | null;
        readonly resource: boolean | null;
        readonly responseStatus: ResponseStatusEnum | null;
        readonly urnType: UrnTypeEnum | null;
        readonly urnValue: string;
        readonly " $fragmentRefs": FragmentRefs<"EventSummaryAttendees_attendees" | "EventSummaryExternalAttendees_attendees" | "EventSummaryRoom_attendees">;
    }>;
    readonly creator: {
        readonly displayName: string | null;
        readonly profileId: string | null;
        readonly optional: boolean | null;
        readonly organizer: boolean | null;
        readonly resource: boolean | null;
        readonly responseStatus: ResponseStatusEnum | null;
        readonly urnType: UrnTypeEnum | null;
        readonly urnValue: string;
    } | null;
    readonly endTime: {
        readonly millis: number;
        readonly timeZone: string | null;
        readonly offsetMinutes: number | null;
    };
    readonly organizer: {
        readonly displayName: string | null;
        readonly profileId: string | null;
        readonly optional: boolean | null;
        readonly organizer: boolean | null;
        readonly resource: boolean | null;
        readonly responseStatus: ResponseStatusEnum | null;
        readonly urnType: UrnTypeEnum | null;
        readonly urnValue: string;
    } | null;
    readonly recurringEventId: string | null;
    readonly recurrenceRules: {
        readonly firstInstanceStartTime: {
            readonly timeZone: string | null;
            readonly offsetMinutes: number | null;
        } | null;
        readonly timeZone: string;
        readonly interval: {
            readonly byDay: string | null;
            readonly count: number | null;
        } | null;
        readonly cancelledInstances: ReadonlyArray<string | null> | null;
    } | null;
    readonly startTime: {
        readonly millis: number;
        readonly timeZone: string | null;
        readonly offsetMinutes: number | null;
    };
    readonly title: string | null;
    readonly transparency: TransparencyEnum | null;
    readonly isAllDay: boolean | null;
    readonly guestsCanInviteOthers: boolean | null;
    readonly guestsCanModify: boolean | null;
    readonly guestsCanSeeOtherGuests: boolean | null;
    readonly locked: boolean | null;
    readonly privateCopy: boolean | null;
    readonly description: string | null;
    readonly location: string | null;
    readonly etag: string | null;
    readonly htmlLink: string | null;
    readonly hangoutLink: string | null;
    readonly annotatedEvent: {
        readonly id: string;
        readonly externalEventId: string | null;
        readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
                readonly lastModified: number;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly active: boolean;
                readonly value: string | null;
            };
        }> | null;
        readonly userTags: ReadonlyArray<{
            readonly tag: string;
            readonly count: number;
            readonly states: ReadonlyArray<{
                readonly lastModified: number;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly active: boolean;
                readonly value: string | null;
            }> | null;
        }> | null;
    } | null;
    readonly createdMillis: unknown | null;
    readonly featureStatesForOrganizer: ({
        readonly __typename: "FeatureStates";
        readonly mixedFreemiumOrgUIState: {
            readonly autopilotPaused: boolean;
            readonly moveRangesEnabled: boolean;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryRecurrence_event" | "EventSummaryTime_event" | "EventSummaryBestTimeRecurrence_event" | "EventSummaryAutopilotFlex_event" | "AutopilotFlexibility_event">;
    readonly " $refType": "OnboardingAutopilotEvent_event";
};
export type OnboardingAutopilotEvent_event$data = OnboardingAutopilotEvent_event;
export type OnboardingAutopilotEvent_event$key = {
    readonly " $data"?: OnboardingAutopilotEvent_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingAutopilotEvent_event">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileId",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optional",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizer",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resource",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseStatus",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnType",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v11 = [
        (v3 /*: any*/),
        (v4 /*: any*/),
        (v5 /*: any*/),
        (v6 /*: any*/),
        (v7 /*: any*/),
        (v8 /*: any*/),
        (v9 /*: any*/),
        (v10 /*: any*/)
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offsetMinutes",
        "storageKey": null
    } as any, v14 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        (v12 /*: any*/),
        (v13 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v17 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastModified",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingAutopilotEvent_event",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClockwiseEvent",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    (v0 /*: any*/),
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hashedCalendars",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "orgId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "organizerPerson",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isYou",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryEmail",
                                "storageKey": null
                            }
                        ],
                        "type": "Person",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Attendee",
                "kind": "LinkedField",
                "name": "attendees",
                "plural": true,
                "selections": [
                    (v3 /*: any*/),
                    (v4 /*: any*/),
                    (v5 /*: any*/),
                    (v6 /*: any*/),
                    (v7 /*: any*/),
                    (v8 /*: any*/),
                    (v9 /*: any*/),
                    (v10 /*: any*/),
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventSummaryAttendees_attendees"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventSummaryExternalAttendees_attendees"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventSummaryRoom_attendees"
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Attendee",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": (v11 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v14 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Attendee",
                "kind": "LinkedField",
                "name": "organizer",
                "plural": false,
                "selections": (v11 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recurringEventId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "RecurrenceRules",
                "kind": "LinkedField",
                "name": "recurrenceRules",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "firstInstanceStartTime",
                        "plural": false,
                        "selections": [
                            (v12 /*: any*/),
                            (v13 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v12 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntervalDefinition",
                        "kind": "LinkedField",
                        "name": "interval",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "byDay",
                                "storageKey": null
                            },
                            (v15 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cancelledInstances",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v14 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transparency",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDay",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guestsCanInviteOthers",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guestsCanModify",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guestsCanSeeOtherGuests",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locked",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privateCopy",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "etag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "htmlLink",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hangoutLink",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgTag",
                        "kind": "LinkedField",
                        "name": "orgTags",
                        "plural": true,
                        "selections": [
                            (v16 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v17 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserTag",
                        "kind": "LinkedField",
                        "name": "userTags",
                        "plural": true,
                        "selections": [
                            (v16 /*: any*/),
                            (v15 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagState",
                                "kind": "LinkedField",
                                "name": "states",
                                "plural": true,
                                "selections": (v17 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdMillis",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureStatesForOrganizer",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "MixedFreemiumOrgUiState",
                                "kind": "LinkedField",
                                "name": "mixedFreemiumOrgUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "autopilotPaused",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "moveRangesEnabled",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureStates",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryRecurrence_event"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryTime_event"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryBestTimeRecurrence_event"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryAutopilotFlex_event"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotFlexibility_event"
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '0d393575e3f1845dd5f141c419f71b63';
export default node;
